import React from 'react';

import type { DefaultOptionType } from 'antd/es/select';

import { hasSwiftray } from '@core/helpers/api/swiftray-client';
import useI18n from '@core/helpers/useI18n';

import { SettingSelect, SettingSwitch, useSettingStore } from '../../shared';

function Performance(): React.JSX.Element {
  const lang = useI18n();
  const { getPreference, setPreference } = useSettingStore();

  const imageDownSamplingOptions = [
    { label: lang.settings.low, value: true },
    { label: lang.settings.normal, value: false },
  ] as unknown as DefaultOptionType[];

  const isUsingSwiftray = getPreference('path-engine') === 'swiftray';

  return (
    <>
      <SettingSelect
        defaultValue={getPreference('image_downsampling')}
        id="set-bitmap-quality"
        label={lang.settings.image_downsampling}
        onChange={(e) => setPreference('image_downsampling', e)}
        options={imageDownSamplingOptions}
        url={lang.settings.help_center_urls.image_downsampling}
      />
      <SettingSwitch
        checked={getPreference('anti-aliasing')}
        id="set-anti-aliasing"
        label={lang.settings.anti_aliasing}
        onChange={(e) => setPreference('anti-aliasing', e)}
        url={lang.settings.help_center_urls.anti_aliasing}
      />
      <SettingSwitch
        checked={getPreference('simplify_clipper_path')}
        id="set-simplify-clipper-path"
        label={lang.settings.simplify_clipper_path}
        onChange={(e) => setPreference('simplify_clipper_path', e)}
        url={lang.settings.help_center_urls.simplify_clipper_path}
      />
      {hasSwiftray && (
        <SettingSwitch
          checked={isUsingSwiftray}
          id="path-engine"
          label={lang.settings.calculation_optimization}
          onChange={(e) => setPreference('path-engine', e ? 'swiftray' : 'fluxghost')}
          url={lang.settings.help_center_urls.calculation_optimization}
        />
      )}
      {hasSwiftray && isUsingSwiftray && (
        <SettingSwitch
          checked={getPreference('use_ga_reorder')}
          id="use-ga-reorder"
          label={lang.settings.vector_order_optimization}
          onChange={(e) => setPreference('use_ga_reorder', e)}
        />
      )}
    </>
  );
}

export default Performance;
